<div class="content-container">
  <!-- Empty State -->
  <div class="empty-state" *ngIf="!hasAnyContent()">
    <div class="empty-state-content">
      <div class="empty-state-illustration">
       
      </div>
      <h3 class="empty-state-title">No Content Available</h3>
      <p class="empty-state-description">You haven't created any content for this campaign yet. Start by selecting platforms and creating content.</p>
      <button class="btn btn-primary btn-medium" (click)="onEditPlatform()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.2487 5.41627L14.582 8.7496M3.33203 16.6663H6.66536L15.4154 7.91627C15.6342 7.6974 15.8079 7.43756 15.9263 7.15159C16.0448 6.86563 16.1057 6.55913 16.1057 6.2496C16.1057 5.94007 16.0448 5.63357 15.9263 5.34761C15.8079 5.06164 15.6342 4.8018 15.4154 4.58293C15.1965 4.36406 14.9367 4.19045 14.6507 4.072C14.3647 3.95354 14.0582 3.89258 13.7487 3.89258C13.4392 3.89258 13.1327 3.95354 12.8467 4.072C12.5607 4.19045 12.3009 4.36406 12.082 4.58293L3.33203 13.3329V16.6663Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Edit Platform
      </button>
    </div>
  </div>

  <!-- Content Sections -->
  <div class="content-sections" *ngIf="hasAnyContent()">
    <!-- Email Section -->
    <div class="content-section" *ngIf="isPlatformSelected('email')">
      <h3 class="section-title">Email</h3>
      <div class="content-card">
        <div class="content-header">
          <div class="content-info">
            <h4 class="content-title">{{ contentData.email.title }}</h4>
            <p class="content-subtitle">{{ contentData.email.subtitle }}</p>
          </div>
          <div class="content-actions">
            <!-- <button class="action-btn preview-btn" (click)="onPreviewClick('email')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.33333 10C8.33333 10.442 8.50893 10.866 8.82149 11.1785C9.13405 11.4911 9.55797 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.866 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333C9.55797 8.33333 9.13405 8.50893 8.82149 8.82149C8.50893 9.13405 8.33333 9.55797 8.33333 10Z" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17.5 10C15.5 13.3333 13 15 10 15C7 15 4.5 13.3333 2.5 10C4.5 6.66667 7 5 10 5C13 5 15.5 6.66667 17.5 10Z" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
                
            </button> -->
            <button class="action-btn edit-btn" (click)="onEditClick('email')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2487 5.41627L14.582 8.7496M3.33203 16.6663H6.66536L15.4154 7.91627C15.6342 7.6974 15.8079 7.43756 15.9263 7.15159C16.0448 6.86563 16.1057 6.55913 16.1057 6.2496C16.1057 5.94007 16.0448 5.63357 15.9263 5.34761C15.8079 5.06164 15.6342 4.8018 15.4154 4.58293C15.1965 4.36406 14.9367 4.19045 14.6507 4.072C14.3647 3.95354 14.0582 3.89258 13.7487 3.89258C13.4392 3.89258 13.1327 3.95354 12.8467 4.072C12.5607 4.19045 12.3009 4.36406 12.082 4.58293L3.33203 13.3329V16.6663Z" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
        </div>
        <div class="content-preview">
          <div class="preview-header">
            <button class="preview-expand-btn" (click)="onExpandClick('email')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.332 3.33301H16.6654M16.6654 3.33301V6.66634M16.6654 3.33301L11.6654 8.33301M6.66536 16.6663H3.33203M3.33203 16.6663V13.333M3.33203 16.6663L8.33203 11.6663M13.332 16.6663H16.6654M16.6654 16.6663V13.333M16.6654 16.6663L11.6654 11.6663M6.66536 3.33301H3.33203M3.33203 3.33301V6.66634M3.33203 3.33301L8.33203 8.33301" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
          <div class="preview-image email-preview" *ngIf="campaign && campaign.contents && campaign.contents.email">
            <app-email-preview
              [emailData]="sampleEmailData"
              (viewInBrowser)="onViewInBrowser()">
            </app-email-preview>
          </div>
        </div>
      </div>
    </div>

    <!-- Text Message Section -->
    <div class="content-section" *ngIf="isPlatformSelected('sms')">
      <h3 class="section-title">Text Message</h3>
      <div class="content-card">
        <div class="content-header">
          <div class="content-info">
            <h4 class="content-title">{{ contentData.textMessage.title }}</h4>
          </div>
          <div class="content-actions">
            <button class="action-btn edit-btn" (click)="onEditClick('textMessage')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2487 5.41627L14.582 8.7496M3.33203 16.6663H6.66536L15.4154 7.91627C15.6342 7.6974 15.8079 7.43756 15.9263 7.15159C16.0448 6.86563 16.1057 6.55913 16.1057 6.2496C16.1057 5.94007 16.0448 5.63357 15.9263 5.34761C15.8079 5.06164 15.6342 4.8018 15.4154 4.58293C15.1965 4.36406 14.9367 4.19045 14.6507 4.072C14.3647 3.95354 14.0582 3.89258 13.7487 3.89258C13.4392 3.89258 13.1327 3.95354 12.8467 4.072C12.5607 4.19045 12.3009 4.36406 12.082 4.58293L3.33203 13.3329V16.6663Z" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
        </div>
        <div class="content-preview">
          <!-- MMS preview bubble(s), split per segment -->
          <div class="message-bubble-container" *ngIf="mmsCampaignPreview as mms">

            <!-- Bubble 1: single caption segment -->
            <ng-container *ngIf="mmsCaptionSegmentParts.length <= 1">
              <div class="message-bubble mms-preview-bubble">
                <div class="bubble-content">
                  <div class="mms-preview-image-box" *ngIf="mms.imageUrl">
                    <img [src]="mms.imageUrl" [alt]="mms.altText || 'MMS image'" class="mms-preview-thumb">
                  </div>
                  <span class="mms-caption-text" *ngIf="mms.caption">{{ mms.caption }}</span>
                  <span class="mms-preview-url" *ngIf="mms.url">{{ mms.url }}</span>
                </div>
              </div>
            </ng-container>

            <!-- Bubble 1: multi-segment caption -->
            <ng-container *ngIf="mmsCaptionSegmentParts.length > 1">
              <div class="segment-group"
                   *ngFor="let part of mmsCaptionSegmentParts; let i = index; trackBy: trackByIndex">
                <div class="message-bubble mms-preview-bubble">
                  <div class="bubble-content">
                    <div class="mms-preview-image-box" *ngIf="i === 0 && mms.imageUrl">
                      <img [src]="mms.imageUrl" [alt]="mms.altText || 'MMS image'" class="mms-preview-thumb">
                    </div>
                    <span class="mms-caption-text">{{ part }}</span>
                    <span class="mms-preview-url" *ngIf="i === 0 && mms.url">{{ mms.url }}</span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Bubble 2: single segment -->
            <ng-container *ngIf="mms.splitTwoBubbles && mms.bubble2Text">
              <ng-container *ngIf="mmsBubble2SegmentParts.length <= 1">
                <div class="message-bubble mms-preview-bubble">
                  <div class="bubble-content">
                    <span>{{ mms.bubble2Text }}</span>
                  </div>
                </div>
              </ng-container>

              <!-- Bubble 2: multi-segment -->
              <ng-container *ngIf="mmsBubble2SegmentParts.length > 1">
                <div class="segment-group"
                     *ngFor="let part of mmsBubble2SegmentParts; let i = index; trackBy: trackByIndex">
                  <div class="message-bubble mms-preview-bubble">
                    <div class="bubble-content">
                      <span>{{ part }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <!-- SMS preview bubble(s), split per segment -->
          <div class="message-bubble-container" *ngIf="!mmsCampaignPreview">

            <!-- Single segment -->
            <ng-container *ngIf="smsSegmentParts.length <= 1">
              <div class="message-bubble">
                <div class="bubble-content">
                  <span [innerHTML]="formatTextMessage(smsSegmentParts[0])"></span>
                </div>
              </div>
            </ng-container>

            <!-- Multi-segment: one bubble per segment -->
            <ng-container *ngIf="smsSegmentParts.length > 1">
              <div class="segment-group"
                   *ngFor="let part of smsSegmentParts; let i = index; trackBy: trackByIndex">
                <div class="message-bubble">
                  <div class="bubble-content">
                    <span [innerHTML]="formatTextMessage(part)"></span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Facebook Ad Section -->
    <div class="content-section" *ngIf="isPlatformSelected('facebook')">
      <h3 class="section-title">Facebook Ad</h3>
      <div class="content-card">
        <div class="content-header">
          <div class="content-info">
            <h4 class="content-title">{{ contentData.facebookAd.title }}</h4>
          </div>
          <div class="content-actions">
            <button class="action-btn edit-btn" (click)="onEditClick('facebookAd')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2487 5.41627L14.582 8.7496M3.33203 16.6663H6.66536L15.4154 7.91627C15.6342 7.6974 15.8079 7.43756 15.9263 7.15159C16.0448 6.86563 16.1057 6.55913 16.1057 6.2496C16.1057 5.94007 16.0448 5.63357 15.9263 5.34761C15.8079 5.06164 15.6342 4.8018 15.4154 4.58293C15.1965 4.36406 14.9367 4.19045 14.6507 4.072C14.3647 3.95354 14.0582 3.89258 13.7487 3.89258C13.4392 3.89258 13.1327 3.95354 12.8467 4.072C12.5607 4.19045 12.3009 4.36406 12.082 4.58293L3.33203 13.3329V16.6663Z" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
        </div>
        <div class="content-preview">
          <app-facebook-ad-preview
            [businessName]="contentData.facebookAd.name || ''"
            [discountText]="contentData.facebookAd.caption || ''"
            [discountPercentage]="contentData.facebookAd.headline || ''"
            [ctaText]="contentData.facebookAd.buttonText || ''"
            [logoUrl]="contentData.facebookAd.logoUrl || ''"
            [imageUrl]="contentData.facebookAd.imageUrl || ''"
            [likes]="129"
            [comments]="12"
            [shares]="8">
          </app-facebook-ad-preview>
        </div>
      </div>
    </div>

    <!-- Google Ad Section -->
    <div class="content-section" *ngIf="isPlatformSelected('google')">
      <h3 class="section-title">Google Ad</h3>
      <div class="content-card">
        <div class="content-header">
          <div class="content-info">
            <h4 class="content-title">Your Google Ad Preview</h4>
          </div>
          <div class="content-actions">
            <button class="action-btn edit-btn" (click)="onEditClick('googleAd')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2487 5.41627L14.582 8.7496M3.33203 16.6663H6.66536L15.4154 7.91627C15.6342 7.6974 15.8079 7.43756 15.9263 7.15159C16.0448 6.86563 16.1057 6.55913 16.1057 6.2496C16.1057 5.94007 16.0448 5.63357 15.9263 5.34761C15.8079 5.06164 15.6342 4.8018 15.4154 4.58293C15.1965 4.36406 14.9367 4.19045 14.6507 4.072C14.3647 3.95354 14.0582 3.89258 13.7487 3.89258C13.4392 3.89258 13.1327 3.95354 12.8467 4.072C12.5607 4.19045 12.3009 4.36406 12.082 4.58293L3.33203 13.3329V16.6663Z" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
        </div>
        <div class="content-preview">
          <app-google-ad-preview
            [adTitle]="contentData.googleAd.title || ''"
            [companyName]="contentData.googleAd.company || ''"
            [backgroundImage]="contentData.googleAd.image || ''">
          </app-google-ad-preview>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Email Preview Modal -->
<app-email-preview-modal 
  *ngIf="isEmailModalOpen && sampleEmailData" 
  [emailData]="sampleEmailData"
  (closeModal)="onCloseEmailModal()"
  (viewInBrowser)="onViewInBrowser()">
</app-email-preview-modal>